import { render, staticRenderFns } from "./DownloadPhoto.vue?vue&type=template&id=f155c160&scoped=true&"
import script from "./DownloadPhoto.vue?vue&type=script&lang=js&"
export * from "./DownloadPhoto.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPhoto.vue?vue&type=style&index=0&id=f155c160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f155c160",
  null
  
)

export default component.exports